
define('text!templates/modules/setting/business/payment/payment-messages.html',[],function () { return '<div class="text-center">\n    <span class="payment-waiting-message">{{#t}}payment:message_paypal_redirection{{/t}}</span>\n    <span class="fa fa-spinner fa-pulse fa-1x fa-fw"></span>\n</div>\n';});

